import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const complMastersAdapter = createEntityAdapter({})

const initialState = complMastersAdapter.getInitialState()

export const complMasterApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getComplMasters: builder.query({
            query: () => ({
                url: '/complmaster',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedComplMasters = responseData.map(complmaster => {
                    // console.log(assetmaster)
                    complmaster.id = complmaster._id
                    // console.log(assetmaster)
                    return complmaster
                });
                return complMastersAdapter.setAll(initialState, loadedComplMasters)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Complmaster', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Complmaster', id }))
                    ]
                } else return [{ type: 'Complmaster', id: 'LIST' }]
            }
        }),
        addNewComplMaster: builder.mutation({
            query: initialUserData => ({
                url: '/complmaster',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Complmaster', id: "LIST" }
            ]
        }),
        updateComplMaster: builder.mutation({
            query: initialUserData => ({
                url: '/complmaster',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Complmaster', id: arg.id }
            ]
        }),
        addSubInCat: builder.mutation({
            query: initialUserData => ({
                url: '/complmaster/addsubject',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Complmaster', id: arg.id }
            ]
        }),
       delSubInArr: builder.mutation({
            query: initialUserData => ({
                url: '/complmaster/deletesubject',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Complmaster', id: arg.id }
            ]
        }),
        // editAssetOfCat: builder.mutation({
        //     query: initialUserData => ({
        //         url: '/complmaster/editasset',
        //         method: 'PUT',
        //         body: {
        //             ...initialUserData,
        //         }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'Assetmaster', id: arg.id }
        //     ]
        // }),
        deleteComplMaster: builder.mutation({
            query: ({ id }) => ({
                url: `/complmaster`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Complmaster', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetComplMastersQuery,
    useAddNewComplMasterMutation,
    useUpdateComplMasterMutation,
    useDelSubInArrMutation,
    useAddSubInCatMutation,
    useDeleteComplMasterMutation    
    // useUpdateAssetMasterMutation,
    // useAddAssetInCatMutation,
    // useEditAssetOfCatMutation
} = complMasterApiSlice

// returns the query result object
export const selectComplMastersResult = complMasterApiSlice.endpoints.getComplMasters.select()

// creates memoized selector
const selectComplMastersData = createSelector(
    selectComplMastersResult,
    complMastersResult => complMastersResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllComplMasters,
    selectById: selectComplMasterById,
    selectIds: selectComplMasterIds
    // Pass in a selector that returns the users slice of state
} = complMastersAdapter.getSelectors(state => selectComplMastersData(state) ?? initialState)